import { Router } from '@angular/router';
import { ItemService } from './../services/item.service';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Spot } from '../models/Item';
import { User } from '../core/user';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { Chart } from 'chart.js';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
 
  isNewUser = true;
  email = '';
  password = '';
  errorMessage = '';
  error: { name: string, message: string } = { name: '', message: '' };

  resetPassword = false;
  userCollection: any;
  users: Observable<User[]>;
  userDocs: any;
  userData: any;
  

  constructor(public itemService: ItemService, private afs: AngularFirestore, public router: Router, public route: ActivatedRoute, private authService: AuthService) { }


  getList() {

    this.userCollection = this.afs.collection('users', ref => ref.where('uid', '==', this.authService.currentUserId));

    this.users = this.userCollection.snapshotChanges().pipe(take(1)).map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as User;
        data.uid = a.payload.doc.id;
        return data;
      });
    });

    return this.users;
    // console.log(this.surveys);
  }

  ngOnInit() {
   this.itemService.defaultDate();
   if (!this.authService.currentUser) {
    this.router.navigate(['/login']);
  }

  // if (this.authService.currentUserId) {
  //   this.userDocs = this.getList();

  //   this.getList().subscribe((querySnapshot) => {
  //     querySnapshot.forEach((doc) => {
  //       this.userData = doc;
  //       this.authService.loggedInUserName = this.userData.userName;
  //       this.authService.loggedInUserRole = this.userData.user_type;
  //       this.authService.loggedInUserClient = this.userData.client;
  //     });
  //   })

  // }
   
  }

  logout() {

    let parameters:any = { attempt: 'Success'}
    this.itemService.logEvent('onLogout', parameters);

    this.authService.signOut();
  }

  checkUserInfo() {
    if (this.authService.isUserEmailLoggedIn) {
      this.router.navigate(['/calendar/list'])
    }
  }

  clearErrorMessage() {
    this.errorMessage = '';
    this.error = { name: '', message: '' };
  }

  changeForm() {
    this.isNewUser = !this.isNewUser
  }



  onLoginEmail(): void {
    this.clearErrorMessage()

    if (this.validateForm(this.email, this.password)) {
      this.authService.loginWithEmail(this.email, this.password)
        .then(() => {
          
          this.router.navigate(['/home'])
        })
        .catch(_error => {
          this.error = _error
          this.router.navigate(['/'])
        })
    }
  }

  validateForm(email: string, password: string): boolean {
    if (email.length === 0) {
      this.errorMessage = 'Please enter Email!'
      return false
    }

    if (password.length === 0) {
      this.errorMessage = 'Please enter Password!'
      return false
    }

    if (password.length < 6) {
      this.errorMessage = 'Password should be at least 6 characters!'
      return false
    }

    this.errorMessage = ''

    return true
  }

  isValidMailFormat(email: string) {
    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if ((email.length === 0) && (!EMAIL_REGEXP.test(email))) {
      return false;
    }

    return true;
  }

  // sendResetEmail() {
  //   this.clearErrorMessage()

  //   this.authService.resetPassword(this.email)
  //     .then(() => this.resetPassword = true)
  //     .catch(_error => {
  //       this.error = _error
  //     })
  // }

 
}





// WEBPACK FOOTER //
// ./src/app/nav/nav.component.ts